/* ==========================================================================
   Silence Store — scelta taglia/colore e aggiunta al carrello.
   Compagno di snippets/silence-scelta.liquid.

   Vale ovunque compaia un prodotto: vetrine della home, collezioni,
   "completa il tuo look". Non tocca la scheda prodotto, che ha il suo.

   Gli ascoltatori stanno sul documento, non sui bottoni: le vetrine
   vengono ridisegnate spesso e un ascoltatore attaccato al bottone
   sparirebbe con lui.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__ssScelta) return;
  window.__ssScelta = true;

  function scuoti(el) {
    if (!el) return;
    el.classList.add('e-no');
    setTimeout(function () { el.classList.remove('e-no'); }, 1200);
  }

  function dati(box) {
    try { return JSON.parse(box.getAttribute('data-varianti')); }
    catch (e) { return []; }
  }

  function scelteDi(box) {
    var s = {};
    box.querySelectorAll('.ss-riga').forEach(function (r) {
      var on = r.querySelector('.ss-tag.is-on');
      if (on) s[r.getAttribute('data-pos')] = on.getAttribute('data-val');
    });
    return s;
  }

  function variante(box) {
    var s = scelteDi(box);
    var t = null;
    dati(box).forEach(function (v) {
      if (t || !v.ok) return;
      var va = true;
      for (var k in s) { if (v.o[Number(k) - 1] !== s[k]) va = false; }
      if (va) t = v;
    });
    return t;
  }

  /* Il tasto non dice mai solo "Aggiungi": finche' manca una scelta dice
     quale manca, appena il cliente ha scelto conferma cosa sta mettendo
     nel carrello. Con taglia e colore insieme conferma solo la taglia,
     sennò sul telefono la scritta va a capo e il tasto si sfascia — il
     colore si vede lo stesso, la sua pastiglia resta accesa. */
  function etichetta(box) {
    var add = box.querySelector('.ss-add');
    if (!add || add.dataset.corso) return;

    var righe = Array.prototype.slice.call(box.querySelectorAll('.ss-riga'));
    var manca = righe.filter(function (r) { return !r.querySelector('.ss-tag.is-on'); });
    var testo;

    if (manca.length === 0) {
      /* Scelta finita: il tasto torna a dire quello che fa davvero, con le
         parole scritte nell'editor. La taglia scelta non serve ripeterla
         qui: la pastiglia sotto resta accesa e si vede. */
      testo = add.getAttribute('data-pronto') || 'Aggiungi al carrello';
    } else if (manca.length === 1) {
      testo = 'Scegli ' + manca[0].getAttribute('data-uno');
    } else if (manca.length === 2) {
      testo = 'Scegli ' + manca[0].getAttribute('data-eti') + ' e ' + manca[1].getAttribute('data-eti');
    } else {
      testo = 'Scegli le opzioni';
    }

    if (add.textContent !== testo) add.textContent = testo;
  }

  /* Spegne i valori che, con quello gia' scelto, non esistono in magazzino.
     Restano visibili ma barrati: chi cerca la sua taglia vede che c'e' ed e'
     finita, invece di chiedersi perche' manca. */
  function aggiorna(box) {
    var lista = dati(box);
    var righe = box.querySelectorAll('.ss-riga');

    righe.forEach(function (r) {
      var pos = Number(r.getAttribute('data-pos'));
      r.querySelectorAll('.ss-tag').forEach(function (tag) {
        var val = tag.getAttribute('data-val');
        var ok = false;
        lista.forEach(function (v) {
          if (ok || !v.ok) return;
          if (v.o[pos - 1] !== val) return;
          var va = true;
          righe.forEach(function (r2) {
            var p2 = Number(r2.getAttribute('data-pos'));
            if (p2 === pos) return;
            var on = r2.querySelector('.ss-tag.is-on');
            if (on && v.o[p2 - 1] !== on.getAttribute('data-val')) va = false;
          });
          if (va) ok = true;
        });
        /* Niente "disabled": un bottone spento non manda nemmeno il clic,
           e la taglia barrata adesso deve poter aprire il "chiedi se torna". */
        tag.classList.toggle('e-fuori', !ok);
        tag.setAttribute('aria-disabled', String(!ok));
      });
    });

    /* Chi sta fuori (per esempio "completa il tuo look", che ha un tasto
       solo in fondo per tutto l'outfit) deve poter sapere cosa ha scelto
       il cliente senza rifare i conti: lo lasciamo scritto sul contenitore
       e mandiamo un avviso a ogni cambio. */
    var scelta = null;
    var completo = true;
    righe.forEach(function (r) {
      if (!r.querySelector('.ss-tag.is-on')) completo = false;
    });
    if (completo) {
      var v = variante(box);
      if (v) scelta = String(v.id);
    }
    if (scelta) box.setAttribute('data-scelta', scelta);
    else box.removeAttribute('data-scelta');

    etichetta(box);

    box.dispatchEvent(new CustomEvent('ss:scelta', {
      bubbles: true,
      detail: { id: scelta }
    }));
  }

  /* Quando il negozio dice di no (per esempio: di quella taglia ne resta uno
     e ce l'hai gia' nel carrello) il cliente deve leggere il perche'. Prima
     il tasto tremava e basta, e sembrava che il sito non funzionasse. */
  function nota(el, testo) {
    var box = el.closest('.ss-scelte') || el.parentElement;
    if (!box) return;
    var p = box.querySelector('.ss-nota');
    if (!p) {
      p = document.createElement('p');
      p.className = 'ss-nota';
      p.setAttribute('role', 'status');
      if (el.nextSibling) box.insertBefore(p, el.nextSibling);
      else box.appendChild(p);
    }
    p.textContent = testo;
    clearTimeout(p.__via);
    p.__via = setTimeout(function () { p.textContent = ''; }, 6000);
  }

  /* Il negozio risponde in due modi diversi a seconda della strada usata:
     a volte {status, description}, a volte {errors}. Qui si tira fuori la
     frase in italiano che manda lui, qualunque forma abbia. */
  function perche(res) {
    if (!res) return '';
    if (typeof res.description === 'string' && res.description) return res.description;
    if (typeof res.message === 'string' && res.message && res.message !== 'Cart Error') return res.message;
    var e = res.errors;
    if (typeof e === 'string' && e) return e;
    if (e && typeof e === 'object') {
      for (var k in e) {
        var v = e[k];
        if (typeof v === 'string' && v) return v;
        if (v && v.length && typeof v[0] === 'string') return v[0];
      }
    }
    return '';
  }

  /* CHIEDI SE TORNA. Il cliente clicca la taglia barrata: sotto compare la
     riga e il tasto verde, con il messaggio gia' scritto — capo, taglia e
     link. Prima quel clic non faceva niente e il cliente se ne andava senza
     che noi sapessimo nemmeno che era passato. */
  var ICONA = '<svg class="ss-wa__i" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23a8.23 8.23 0 0 1 0 16.47Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.15.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.4-.42-.56-.43h-.47c-.16 0-.43.06-.65.31-.22.25-.85.83-.85 2.03s.87 2.35.99 2.51c.12.17 1.71 2.61 4.14 3.66.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.47-.29Z"/></svg>';

  function chiediSeTorna(tag) {
    var box = tag.closest('.ss-scelte');
    if (!box || !box.getAttribute('data-wa-num')) return;

    var riga = tag.closest('.ss-riga');
    var eti = riga ? (riga.getAttribute('data-eti') || '') : '';
    var val = tag.getAttribute('data-val') || '';

    var testo = box.getAttribute('data-wa-msg') + ' ' + box.getAttribute('data-capo');
    if (eti) testo += ' — ' + eti + ' ' + val;
    testo += ' — ' + box.getAttribute('data-link');

    var blocco = box.querySelector('.ss-torna');
    if (!blocco) {
      blocco = document.createElement('div');
      blocco.className = 'ss-torna';
      blocco.innerHTML = '<p class="ss-torna__t"></p>' +
        '<a class="ss-wa" target="_blank" rel="noopener">' + ICONA +
        '<span class="ss-wa__t"></span></a>';
      box.appendChild(blocco);
    }
    blocco.querySelector('.ss-torna__t').textContent =
      val + ' ' + box.getAttribute('data-wa-manca') + ' ' + box.getAttribute('data-wa-riga');
    var a = blocco.querySelector('.ss-wa');
    blocco.querySelector('.ss-wa__t').textContent = box.getAttribute('data-wa-btn');
    a.href = 'https://wa.me/' + box.getAttribute('data-wa-num') +
             '?text=' + encodeURIComponent(testo);
  }

  function viaSeTorna(box) {
    var b = box && box.querySelector('.ss-torna');
    if (b) b.parentNode.removeChild(b);
  }

  function manda(el, id, testo) {
    if (!id || el.dataset.corso) return;
    el.dataset.corso = '1';
    el.classList.add('is-corso');
    if (testo !== false) el.textContent = 'Aggiungo...';

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (res) { return { ok: r.ok, res: res }; });
      })
      .then(function (esito) {
        var res = esito.res;
        /* Non basta guardare dentro la risposta: quando il negozio dice di no
           lo dice con il codice HTTP, e la frase dentro cambia forma. */
        if (!esito.ok || res.status) throw new Error(perche(res) || 'no');

        var d = document.querySelector('cart-drawer');
        if (d && typeof d.renderContents === 'function' && res.sections) {
          d.renderContents(res);

          /* Se la pagina era stata aperta con il carrello vuoto, il cassetto
             porta addosso la marcatura "is-empty" che nasconde intestazione,
             capi e fondo. Dopo un'aggiunta vuoto non e' piu': va tolta, sennò
             si apre un pannello bianco con dentro niente. */
          d.classList.remove('is-empty');
          var dentro = d.querySelector('.drawer__inner');
          if (dentro) dentro.classList.remove('is-empty');

          if (typeof d.open === 'function') d.open();
          else d.classList.add('active');
        } else {
          window.location.reload();
        }
        delete el.dataset.corso;
        el.classList.remove('is-corso');
        if (testo !== false) el.textContent = testo;
      })
      .catch(function (err) {
        delete el.dataset.corso;
        el.classList.remove('is-corso');
        if (testo !== false) el.textContent = testo;
        scuoti(el);
        nota(el, (err && err.message && err.message !== 'no')
          ? err.message
          : 'Non riesco ad aggiungerlo, riprova.');
      });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    /* una pastiglia: seleziona e basta, non aggiunge niente */
    var tag = t.closest('.ss-tag');
    if (tag) {
      ev.preventDefault();
      ev.stopPropagation();

      /* taglia finita: non si sceglie, si chiede se torna */
      if (tag.classList.contains('e-fuori')) { chiediSeTorna(tag); return; }

      viaSeTorna(tag.closest('.ss-scelte'));
      var riga = tag.closest('.ss-riga');
      var pastiglie = riga.querySelectorAll('.ss-tag');

      /* Ri-cliccare quella gia' accesa la spegne. Serve davvero: scegli la
         taglia S, poi vedi che il colore che volevi in S non c'e' ed e'
         barrato — senza questo il cliente resta incastrato e deve ricaricare
         la pagina. Le righe con un valore solo (taglia unica) non si
         spengono: non avrebbe senso. */
      var gia = tag.classList.contains('is-on');
      pastiglie.forEach(function (x) { x.classList.remove('is-on'); });
      if (!gia || pastiglie.length === 1) tag.classList.add('is-on');

      aggiorna(tag.closest('.ss-scelte'));
      return;
    }

    var b = t.closest('.ss-add');
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();

    /* capo senza opzioni: l'id ce l'ha addosso */
    var diretto = b.getAttribute('data-id');
    if (diretto) { manda(b, diretto, b.textContent); return; }

    var box = b.closest('.ss-scelte');
    if (!box) return;

    /* manca una scelta: scuote la riga che manca, e non tocca il carrello */
    var vuota = null;
    box.querySelectorAll('.ss-riga').forEach(function (r) {
      if (!vuota && !r.querySelector('.ss-tag.is-on')) vuota = r;
    });
    if (vuota) { scuoti(vuota); scuoti(b); return; }

    var v = variante(box);
    if (!v) { scuoti(b); return; }
    manda(b, String(v.id), b.textContent);
  });

  function accendi() {
    document.querySelectorAll('.ss-scelte').forEach(function (box) {
      if (box.classList.contains('is-vuota')) return;
      aggiorna(box);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', accendi);
  } else {
    accendi();
  }

  /* Le vetrine possono arrivare dopo (caroselli, filtri, sezioni ridisegnate
     dall'editor): si ricontrolla quando compare roba nuova. */
  var attesa = null;
  new MutationObserver(function () {
    clearTimeout(attesa);
    attesa = setTimeout(accendi, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
